import * as React from "react";
import AuthorFeaturedProduct, {
    AuthorFeaturedProductProps
} from "~/components/author-featured-product/author-featured-product";

export interface AuthorFeaturedProductViewProps {
    contextModel: AuthorFeaturedProductProps;
}

class AuthorFeaturedProductView extends React.Component<AuthorFeaturedProductViewProps> {
    public render() {
        return <AuthorFeaturedProduct {...this.props.contextModel} />;
    }
}

export default AuthorFeaturedProductView;
